(function (angular) {
    'use strict';


    const WidgetType = {
        Default: "default",
        None: "none"
    }


    angular.module('Common')

        /**
         * 
         */
        .factory('themeService',
            ['$http', '$q', 'portalConfig', 'localStorageService', 'jwtService',
                function ($http, $q, portalConfig, localStorageService, jwtService) {

                    var urlBase = portalConfig.urlBase;

                    var fac = {
                        loadTheme: loadTheme,
                        getThemeInfo: getThemeInfo,
                        theme: localStorageService.getObject("theme") || {
                            logoUrl: "/assets/img/ddg3-white.png",
                            rssFeedUrl: "https://www.comapi.com/feed/",
                            widgetType: WidgetType.None,
                            // colourPalette: {
                            //     primary: "#093d79",
                            //     success: "#00b20f",
                            //     info: "#2B97EF",
                            //     warning: "#FF8340",
                            //     danger: "#9c0046"    
                            // }
                            // dot dig colors: 
                            colourPalette: {
                                primary: "#221C35",
                                success: "#006747",
                                info: "#0014B9",
                                warning: "#FF8340",
                                danger: "#8A2A2B"
                            }
                        },
                    };

                    function getThemeInfo() {
                        if (fac.theme.logoUrl === "/assets/img/dot_cpaasComapi.svg") {
                            fac.theme.logoUrl = "/assets/img/ddg3-white.png";
                        }

                        return fac.theme;
                    }

                    function loadTheme() {

                        return $http.get(urlBase + "/accounts/" + jwtService.payload.accountId + "/theme")
                            .then(loadThemeComplete)
                            .catch(loadThemeFailed);

                        function loadThemeComplete(response) {
                            if (response.data && response.data.colourPalette) {
                                localStorageService.setObject("theme", response.data);
                                fac.theme = response.data;
                            }

                            return response.data;
                        }

                        function loadThemeFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }

                    return fac;
                }]);

})(window.angular);